<script>
    import { onMount } from 'svelte';
    import MorningRoutine from '../components/MorningRoutine.svelte';
    import NightRoutine from '../components/NightRoutine.svelte';
    export let goBackToRecommendations;
    import Button from '../components/Button.svelte';
    import { regimenStore } from '../store.js';

    let morningProducts = [];
    let nightProducts = [];

    $: if ($regimenStore.morning && $regimenStore.night) {
        morningProducts = $regimenStore.morning;
        nightProducts = $regimenStore.night;
        console.log("Updated morningProducts:", morningProducts);
        console.log("Updated nightProducts:", nightProducts);
    }

    onMount(() => {
        window.scrollTo(0, 0);
    });

    // let selectedDay = "All";
    // const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "All"];

    // const regimen = daysOfWeek.reduce((acc, day) => {
    //   acc[day] = {
    //     morning: routine.morning || [],
    //     night: routine.night || []
    //   };
    //   return acc;
    // }, {});

    function generateStars(rating) {
        const fullStars = Math.floor(rating);
        const halfStar = (rating - fullStars) >= 0.5;
        const emptyStars = '☆'.repeat(5 - Math.ceil(rating));

        return { fullStars, halfStar, emptyStars };
    }

</script>

<style>
    /* Dark Editorial - Routine
       Morning and night are two halves of one regimen, so they sit under one
       masthead on one rule, side by side where there is room for them. The two
       lists bring their own panel, so this screen adds no second box around
       them. */
    .regimen {
        max-width: 940px;
    }

    .masthead {
        text-align: center;
        margin-bottom: var(--space-12);
        padding-bottom: var(--space-8);
        border-bottom: 1px solid var(--border);
    }

    .eyebrow {
        font-family: var(--font-body);
        font-size: var(--text-2xs);
        font-weight: var(--weight-medium);
        letter-spacing: var(--track-eyebrow);
        text-transform: uppercase;
        color: var(--text-muted);
        margin: 0 0 var(--space-5);
    }

    .masthead h1 {
        font-family: var(--font-display);
        font-size: var(--text-3xl);
        font-weight: var(--weight-regular);
        line-height: var(--leading-snug);
        letter-spacing: var(--track-tight);
        color: var(--cream);
        margin: 0 0 var(--space-4);
    }

    .lede {
        font-family: var(--font-body);
        font-size: var(--text-sm);
        font-weight: var(--weight-light);
        line-height: var(--leading-relaxed);
        color: var(--text-muted);
        max-width: 56ch;
        margin: 0 auto;
    }

    /* Intrinsic: two halves on a laptop, one column on a phone, no breakpoint. */
    .halves {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
        gap: var(--space-8);
        align-items: start;
    }

    .actions {
        display: flex;
        justify-content: center;
        margin-top: var(--space-10);
    }
</style>

<div class="u-page regimen">
    <header class="masthead">
        <p class="eyebrow">Your regimen</p>
        <h1>Morning and night</h1>
        <p class="lede">One routine in two halves. The morning list is there to protect your skin through the day, the night list to repair it while you sleep.</p>
    </header>

    <div class="halves">
        <MorningRoutine {morningProducts} {generateStars} />
        <!-- <MorningRoutine morningProducts={regimen[selectedDay].morning} generateStars={generateStars} /> -->

        <NightRoutine {nightProducts} {generateStars} />
        <!-- <NightRoutine nightProducts={regimen[selectedDay].night} generateStars={generateStars} /> -->
    </div>

    <div class="actions">
        <Button variant="secondary" on:click={goBackToRecommendations}>Back to recommendations</Button>
    </div>
</div>
